import styled from 'styled-components'
// eslint-disable-next-line import/prefer-default-export
export const LocationWrapper = styled.article`
  width: 100%;
  .ant-input {
    height: 52px !important;
    border-radius: 8px !important;
  }
`
